import {createBrowserRouter} from "react-router-dom";
import {UrlyPage} from "./UrlyPage";
import {EditPage} from "./EditPage";
import {NotFoundPage} from "./NotFoundPage";

export const router = createBrowserRouter([
  {
    path: '/',
    element: <UrlyPage/>,
    index: true,
  },
  {
    path: '/edit/:key',
    element: <EditPage/>,
  },
  {
    path: '*',
    element: <NotFoundPage/>,
  }
])